import { render, staticRenderFns } from "./AddVessel.vue?vue&type=template&id=65dce9ba&scoped=true&"
import script from "./AddVessel.vue?vue&type=script&lang=js&"
export * from "./AddVessel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dce9ba",
  null
  
)

export default component.exports